import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";

function ImpersonationBanner({ impersonatedUser, onExit }) {
  if (!impersonatedUser) return null;

  return (
    <div
      className="w-full px-4 py-2 flex items-center justify-center gap-3 text-sm font-medium"
      style={{ backgroundColor: "#ec4899", color: "#fff" }}
      data-testid="impersonation-banner"
    >
      <span>
        You are viewing as{" "}
        <strong>{impersonatedUser.name || impersonatedUser.email}</strong>
        {impersonatedUser.name && (
          <span className="opacity-80 ml-1">({impersonatedUser.email})</span>
        )}
      </span>
      <Button
        size="sm"
        variant="secondary"
        className="h-7 bg-white/20 hover:bg-white/30 text-white border-0"
        onClick={onExit}
        data-testid="exit-impersonation-btn"
      >
        <LogOut className="h-3.5 w-3.5 mr-1" />
        Exit
      </Button>
    </div>
  );
}

export default ImpersonationBanner;
